import React from "react";
import { Check } from "lucide-react";
import { ZODIAC_GLYPH } from "./chat/chatUtils";

export function CandidateList({ candidates, selected, onToggle }) {
  return (
    <div className="max-h-64 overflow-y-auto space-y-1 pr-1" data-testid="create-group-candidates">
      {candidates.length === 0 && <div className="text-xs text-[#A89C98]">No travelers yet.</div>}
      {candidates.map((c) => {
        const isOn = selected.has(c.user_id);
        return (
          <button
            key={c.user_id}
            data-testid={`create-group-toggle-${c.user_id}`}
            onClick={() => onToggle(c.user_id)}
            className={`w-full flex items-center gap-3 p-2 rounded-md text-left transition-colors ${isOn ? "bg-[#4A3356]/50 border border-[#C8A96E]/40" : "hover:bg-white/5 border border-transparent"}`}
          >
            <img src={c.picture || "https://via.placeholder.com/40"} alt="" className="w-8 h-8 rounded-full border border-white/20" />
            <div className="flex-1 min-w-0">
              <div className="text-sm text-white truncate">{c.name}</div>
              <div className="text-[10px] text-[#A89C98]">{ZODIAC_GLYPH[c.zodiac] || "·"} {c.personalized_tag || c.zodiac || "?"}</div>
            </div>
            {isOn && <Check size={14} className="text-[#C8A96E]" />}
          </button>
        );
      })}
    </div>
  );
}
